import {
  Routes as RouterRoutes,
  Route,
  useLocation,
} from 'react-router-dom'
import LandingPage1 from '../components/LandingPage1/LandingPage1'
import PrelaunchPage from '../components/PrelaunchPage/PrelaunchPage'
import Dashboard from '../components/Dashboard/Dashboard'
import CompanyInfo from '../components/CompanyInfo/CompanyInfo'
import Projects from '../components/Projects/Projects'
import Employees from '../components/Employees/Employees'
import SettingsPage from '../components/SettingsPage/SettingsPage'
import AuthenticatedStackedLayout from '../components/AuthenticatedStackedLayout'
import { useAuth } from '../contexts/AuthContext/AuthContext'
import { EnhancedUIDemo } from '../components/ui/EnhancedUIDemo'
import { LoginPage } from '../components/LoginPage/LoginPage'
import { SignupPage } from '../components/SignupPage/SignupPage'
import { PasswordResetRequestPage } from '../components/PasswordResetRequestPage/PasswordResetRequestPage'
import { PasswordResetFormPage } from '../components/PasswordResetFormPage/PasswordResetFormPage'

function ResetPasswordFormRouteWrapper() {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const token = params.get('token') || ''
  return <PasswordResetFormPage token={token} />
}

function AuthenticatedRoute({
  children, currentPath 
}: { children: React.ReactNode, currentPath: string }) {
  const {
    isAuthenticated, user, logout, isLoading 
  } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-gray-900 mb-4">Authentication Required</h1>
          <p className="text-gray-600 mb-6">Please log in to access this page.</p>
          <a 
            href="/login" 
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Go to Login
          </a>
        </div>
      </div>
    )
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <AuthenticatedStackedLayout
      currentPath={currentPath}
      user={user}
      onLogout={logout}
    >
      {children}
    </AuthenticatedStackedLayout>
  )
}

function Routes() {
  return (
    <RouterRoutes>
      <Route path="/" element={<PrelaunchPage />} />
      <Route path="/landing" element={<LandingPage1 />} />
      <Route path="/demo" element={<EnhancedUIDemo />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={
        <AuthenticatedRoute currentPath="/dashboard">
          <Dashboard />
        </AuthenticatedRoute>
      } />
      <Route path="/company-info" element={
        <AuthenticatedRoute currentPath="/company-info">
          <CompanyInfo />
        </AuthenticatedRoute>
      } />
      <Route path="/projects" element={
        <AuthenticatedRoute currentPath="/projects">
          <Projects />
        </AuthenticatedRoute>
      } />
      <Route path="/employees" element={
        <AuthenticatedRoute currentPath="/employees">
          <Employees />
        </AuthenticatedRoute>
      } />
      <Route path="/profile/settings" element={
        <AuthenticatedRoute currentPath="/profile/settings">
          <SettingsPage />
        </AuthenticatedRoute>
      } />
      <Route path="/register" element={<SignupPage />} />
      <Route path="/forgot-password" element={<PasswordResetRequestPage />} />
      <Route path="/reset-password" element={<ResetPasswordFormRouteWrapper />} />
    </RouterRoutes>
  )
}

export default Routes 